import { Stack, styled } from "@mui/material";

export const AuthLayoutWrapper = styled(Stack)(({ theme }) => {
    return {
        flexDirection: "row",
        minHeight: "100vh",
        backgroundColor: "var(--primary-color)",
        "& .image-box": {
            flex: 1,
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "inherit",
            [theme.breakpoints.down("laptop")]: {
                display: "none",
            }
        },
        "& .form-box": {
            flex: 1,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "var(--light-color)",
            borderRadius: "16px 0 0 16px",
            [theme.breakpoints.down("laptop")]: {
                padding: "var(--basic-padding)",
            }
        },
    }
});
